import {
	createState,
} from './simpleDataList';

import {
	loadSitemapsRangeViaApi,
} from '~/model/sitemaps';



export const {
	loadData,
	reducer,
	selector,
} = createState(
	'sitemapsViolatingUrlcountLimit',
	(websiteId) => loadSitemapsRangeViaApi(websiteId, {
		'fields': 'url,number_of_records',
		'filter[number_of_records]': '>50000',
		'offset': 0,
		'limit': 1000,
	}),
	30,
);
